import { render, staticRenderFns } from "./MPopUp.vue?vue&type=template&id=6bab5256&scoped=true&"
import script from "./MPopUp.vue?vue&type=script&lang=js&"
export * from "./MPopUp.vue?vue&type=script&lang=js&"
import style0 from "./MPopUp.vue?vue&type=style&index=0&id=6bab5256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bab5256",
  null
  
)

export default component.exports